import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LocalStorageHelperService } from 'src/app/shared/services/local-storage-helper.service';
import { RvshareAppDetectionService } from '../../../services/rvshare-app-detection.service';
import { RvshareWindowsModalService } from '../../../services/rvshare-windows-modal.service';

@Component({
  selector: 'moderator-join-desktop-app-banner',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './moderator-join-desktop-app-banner.component.html',
})
export class ModeratorJoinDesktopAppBannerComponent {
  static readonly DISMISSED_KEY = 'moderator-join-desktop-app-banner-dismissed';

  private localStorageHelper = inject(LocalStorageHelperService);
  private rvshareAppDetectionService = inject(RvshareAppDetectionService);
  private rvshareWindowsModalService = inject(RvshareWindowsModalService);

  // Nothing to promote to someone already in one of our apps, the desktop one included.
  visible =
    window.electron?.isRVShareElectron !== true &&
    !this.rvshareAppDetectionService.isScreenShareApp() &&
    !this.isDismissed();

  learnMore(): void {
    void this.rvshareWindowsModalService.show();
  }

  dismiss(): void {
    this.visible = false;
    try {
      this.localStorageHelper.set(
        ModeratorJoinDesktopAppBannerComponent.DISMISSED_KEY,
        true,
      );
    } catch (error) {
      console.log(
        'Failed to remember the dismissed desktop app banner:',
        error,
      );
    }
  }

  private isDismissed(): boolean {
    try {
      return (
        this.localStorageHelper.get(
          ModeratorJoinDesktopAppBannerComponent.DISMISSED_KEY,
        ) === true
      );
    } catch (error) {
      return false;
    }
  }
}
